module.exports = __webpack_public_path__ + "static/media/hex_fortified_line.998a16b3.png";